import { render, staticRenderFns } from "./InformativeText.vue?vue&type=template&id=18f3aab1"
import script from "./InformativeText.vue?vue&type=script&lang=js"
export * from "./InformativeText.vue?vue&type=script&lang=js"
import style0 from "./InformativeText.vue?vue&type=style&index=0&id=18f3aab1&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports